import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownProps {
  dark?: boolean;
}
export function Countdown({
  dark = false
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Minutes'
  }, {
    value: seconds,
    label: 'Seconds'
  }];
  return <div className="mt-6 text-center" role="timer" aria-live="off" data-id="element-2" data-mp="3c0ur3k589adp">
      <p className={`flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-wide ${dark ? 'text-white' : 'text-brand'}`} data-id="element-3" data-mp="3h0pbr5yet3qb">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-4" data-mp="3259haztx35te" />
        The special offer ends in:
      </p>
      <div className="mt-3 flex items-start justify-center gap-2 sm:gap-3" data-id="element-5" data-mp="373b703lum3du">
        {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-6" data-mp="10a8te5k4rtwv" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-7" data-mp="15by3nizj43jw">
              <span className={`flex h-16 w-16 items-center justify-center rounded-xl font-serif text-3xl font-bold tabular-nums sm:h-20 sm:w-20 sm:text-4xl ${dark ? 'bg-white text-brand-dark' : 'bg-brand-dark text-white'}`} data-id="element-8" data-mp="159bx9modju39">
                {unit.value}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${dark ? 'text-brand-light' : 'text-muted'}`} data-id="element-9" data-mp="12rmxyt1z9pcj">
                {unit.label}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-4 font-serif text-3xl font-bold sm:pt-5 ${dark ? 'text-white' : 'text-brand-dark'}`} data-id="element-10" data-mp="a52ba5wg61fb">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}